export const setToken = (t) => localStorage.setItem("fz_token", t);
export const getToken = () => localStorage.getItem("fz_token");
export const clearToken = () => localStorage.removeItem("fz_token");
export const isAuthed = () => !!getToken();
